import { AgentModel } from 'api-hooks/agent';
import { generateId } from 'common/utils/string';
import React from 'react';

import {
  AgentBillingFormType,
  AgentContactFormType,
  AgentFormType,
} from '../components/form-type';

export function onAddNewContact(): AgentContactFormType {
  return {
    customId: generateId(),
    description: '',
    email: '',
    id: undefined,
    name: '',
    phone: '',
    phone_2: '',
  };
}
export function onAddNewBilling(): AgentBillingFormType {
  return {
    accountNumber: '',
    address: '',
    bank: '',
    customId: generateId(),
    id: undefined,
    name: '',
    phone: '',
    phone_2: '',
  };
}

export default function useGetDefaultValues(agent?: AgentModel): AgentFormType {
  const defaultValues = React.useMemo(() => {
    const billings: AgentBillingFormType[] =
      agent?.billings?.map((billing) => {
        return {
          id: billing.id,
          accountNumber: billing.accountNumber || '',
          address: billing.address || '',
          bank: billing.bank || '',
          customId: generateId(),
          name: billing.name || '',
          phone: billing.phone || '',
          phone_2: billing.phone_2 || '',
        };
      }) || [];

    const contacts: AgentContactFormType[] =
      agent?.contacts?.map((contact) => {
        return {
          customId: generateId(),
          description: contact.description || '',
          email: contact.email || '',
          id: contact.id,
          name: contact.name || '',
          phone: contact.phone || '',
          phone_2: contact.phone_2 || '',
        };
      }) || [];

    return {
      address: agent?.address || '',
      balance: agent?.balance || undefined,
      billings,
      contacts,
      description: agent?.description || '',
      email: agent?.email || '',
      name: agent?.name || '',
      phone: agent?.phone || '',
      phone_2: agent?.phone_2 || '',
      system: {
        duePeriod: agent?.system?.duePeriod || 0,
        isTransactionLimited: agent?.system?.isTransactionLimited || false,
        transactionLimit: agent?.system?.transactionLimit || 0,
        remainingTransactionQuota:
          agent?.system?.remainingTransactionQuota || 0,
      },
      data: agent,
    };
  }, [agent]);

  return defaultValues;
}
